import React, { useRef } from 'react';
import './Pricing.scss';
import Credit from './partials/Credit/Credit';
import WorkM from './partials/WorkM/WorkM';
import Heading from './partials/Heading/Heading';
import EarnM from './partials/EarnM/EarnM';
import Bonus from './partials/Bonus/Bonus';
import Refer from './partials/Refer/Refer';
import Subscription from './partials/Subscription/Subscription';
import StudentPlan from './partials/StudentPlan/StudentPlan';

export default function Pricing() {
  const workRef = useRef(null);
  const earnRef = useRef(null);
  const subRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='pricing-container'>
      <Credit
        onHowWorkClick={() => scrollToSection(workRef)}
        onEarnClick={() => scrollToSection(earnRef)}
        onSubClick={() => scrollToSection(subRef)}
      />
      <div ref={workRef}><WorkM /></div>
      <Heading />
      <div ref={earnRef}><EarnM /></div>
      <Bonus />
      <Refer />
      <div ref={subRef}><Subscription /></div>
      <StudentPlan />
    </div>
  )
}
